import { getCookie } from 'lib/cookies'

const CONSTRUCTOR_INDEX_COOKIE = 'constructor_prod_index'

export const getConstructorIndex = (): string => {
  const { CONSTRUCTOR_QA_API_KEY, CONSTRUCTOR_PRODUCTION_API_KEY, APP_ENV } = process.env

  const isProductionEnvironment = APP_ENV === 'production'
  const constructorCookieValue = getCookie({ name: CONSTRUCTOR_INDEX_COOKIE }) || ''
  const shouldUseProductionIndex = constructorCookieValue === '1'
  const constructorIndex =
    shouldUseProductionIndex || isProductionEnvironment
      ? CONSTRUCTOR_PRODUCTION_API_KEY
      : CONSTRUCTOR_QA_API_KEY

  return constructorIndex || ''
}
